export default {
  addOns: '附加項目',
  all: '全部',
  browse: '瀏覽',
  buyTickets: '購買門票',
  countSelected: '已選 {{count}}',
  joinWaitlist: '加入候補名單',
  joining: '加入中',
  noDatesAvailable: '無可用日期',
  salesEnded: '銷售已結束',
  schedule: '行程',
  seeMoreDates: '查看更多日期',
  soldOut: '已售完',
  about: '關於',
  agenda: '行程',
  menu: '菜單',
  included: '包含內容',
  viewMore: '查看更多',
  viewLess: '收起',
  location: '地點',
  time: '時間',
  at: '於',
  noTimesAvailableOnThisDateFotThisPartySize: '此日期無符合人數的可用時段',
  availableTimes: '可用時段',
  waitlist: '候補名單',
  continue: '繼續',
  tickets: '票券',
  ticketsAreNoLongerAvailable: '門票已無法購買。',
  checkOutOutOtherExperiences: '看看我們的其他體驗！',
  viewExperiences: '查看體驗',
  from: '起',
  cancellationPolicy: '取消政策',
  rsvp: '回覆出席',
  nights: '晚',
  request: '申請',
  arrival: '抵達',
  departure: '離開',
};
